import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-menu',
  templateUrl: './gas-icon-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconMenuComponent { }
